import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["search", "results", "contact", "name", "email"]
  static values = { url: String }
  disconnect() { clearTimeout(this.timer); this.abort?.abort() }
  search() {
    clearTimeout(this.timer)
    this.abort?.abort()
    this.resultsTarget.replaceChildren()
    if (this.searchTarget.value.trim().length < 2) return
    this.timer = setTimeout(() => this.load(), 200)
  }
  clearContact() { this.contactTarget.value = "" }
  async load() {
    const request = this.abort = new AbortController()
    const url = new URL(this.urlValue, location.origin)
    url.searchParams.set("q", this.searchTarget.value)
    try {
      const response = await fetch(url, { signal: request.signal, headers: { Accept: "application/json" } })
      if (!response.ok) throw new Error()
      const contacts = await response.json()
      if (request.signal.aborted) return
      this.resultsTarget.replaceChildren()
      contacts.forEach(contact => {
        const button = document.createElement("button")
        button.type = "button"
        button.className = "btn btn-outline-secondary text-start"
        button.textContent = `${contact.name} · ${contact.email}`
        button.addEventListener("click", () => {
          this.contactTarget.value = contact.id
          this.nameTarget.value = contact.name
          this.emailTarget.value = contact.email
          this.resultsTarget.replaceChildren()
          this.searchTarget.value = contact.name
        })
        this.resultsTarget.append(button)
      })
      if (!contacts.length) this.resultsTarget.textContent = "No matching contacts. Enter their details below."
    } catch (error) {
      if (error.name !== "AbortError") this.resultsTarget.textContent = "Contacts could not be loaded. Enter their details below."
    }
  }
}
